import { Button, Grid, MenuItem } from "@mui/material";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getArtPrestadores } from "../../../../../actions/arts";
import { fetchPrestadoresTraslado } from "../../../../../actions/traslados";
import { getFormModel } from "../../../../../actions/forms";
import FormikTextField from "../../../../commons/formik/formikTextField";
import FormikSelect from "../../../../commons/formik/formikSelect";
import FormikCheckbox from "../../../../commons/formik/formikCheckbox";
import FormikDatePicker from "../../../../commons/formik/formikDatePicker";
import { StyledPaper } from "../../../../styled/paper";
import {
  catalogOptionLabel,
  getFormFieldOptions,
} from "../../../forms/fptTraslados/fptTrasladosUtils";

const BuscarTrasladosFilter = ({ initialValues, onSearch, onClear, esPT }) => {
  const dispatch = useDispatch();
  const formModel = useSelector((state) => state.forms.model);
  const searchModel = useSelector((state) => state.traslados.searchModel);
  const searchModelData = searchModel?.data || {};
  const [prestadoresTraslado, setPrestadoresTraslado] = useState([]);
  const [prestadoresLoading, setPrestadoresLoading] = useState(false);
  const artPrestadores = useSelector((state) => state.arts.artPrestadores);
  const idArt = useSelector(
    (state) =>
      state.auth.artAsociada?.id ||
      state.formsState.commonProperties?.idArt ||
      artPrestadores?.data?.[0]?.arts?.[0]?.id,
  );
  const idSiniestro = useSelector(
    (state) => state.formsState.commonProperties?.idSiniestro || 0,
  );

  const fields = formModel?.data?.fields;
  const catalogsLoading = Boolean(
    formModel?.isFetching || artPrestadores?.isFetching,
  );
  const hasFptCatalogs = Boolean(fields?.idAgencia || fields?.IdAgencia);
  const estadosFpt = getFormFieldOptions(fields, "estados", "Estados");
  const estados = estadosFpt.length ? estadosFpt : (searchModelData.estados || []);
  const provinciasFpt = getFormFieldOptions(fields, "provinciaDesde", "ProvinciaDesde");
  const provincias = provinciasFpt.length ? provinciasFpt : (searchModelData.provincias || []);
  const tiposTransporteFpt = getFormFieldOptions(fields, "tipoTransporteNombre", "TipoTransporteNombre");
  const tiposTransporte = tiposTransporteFpt.length ? tiposTransporteFpt : (searchModelData.tiposTransporte || []);

  const provinciasOld = getFormFieldOptions(
    fields,
    "provinciaDesde",
    "ProvinciaDesde",
  );
  const agenciasFpt = getFormFieldOptions(fields, "idAgencia", "IdAgencia");
  const agencias = agenciasFpt.length ? agenciasFpt : (searchModelData.agencias || []);
  const gestoresFpt = getFormFieldOptions(fields, "gestores", "Gestores");
  const gestores = gestoresFpt.length ? gestoresFpt : (searchModelData.gestores || []);
  const gestoresUnused = getFormFieldOptions(fields, "gestores", "Gestores");
  const tiposTransporteUnused = getFormFieldOptions(
    fields,
    "tipoTransporteNombre",
    "TipoTransporteNombre",
  );
  const prestadores = artPrestadores?.data || [];

  useEffect(() => {
    if (!artPrestadores?.data?.length && !artPrestadores?.isFetching) {
      dispatch(getArtPrestadores());
    }
    setPrestadoresLoading(true);
    dispatch(fetchPrestadoresTraslado())
      .then((data) => {
        setPrestadoresTraslado(data || []);
      })
      .catch(() => setPrestadoresTraslado([]))
      .finally(() => setPrestadoresLoading(false));
  }, [dispatch, artPrestadores?.data?.length, artPrestadores?.isFetching]);

  useEffect(() => {
    if (
      !idArt ||
      formModel?.isFetching ||
      formModel?.didInvalidate ||
      hasFptCatalogs
    ) {
      return;
    }
    dispatch(getFormModel("fpt", idArt, idSiniestro || 0));
  }, [
    dispatch,
    idArt,
    idSiniestro,
    formModel?.isFetching,
    formModel?.didInvalidate,
    hasFptCatalogs,
  ]);

  return (
    <StyledPaper.Container>
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSearch(values);
        }}
        enableReinitialize
      >
        {({ resetForm }) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="NroSiniestro" label="Siniestro" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="DocumentoTrabajador" label="Documento Trabajador" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="Trabajador" label="Trabajador" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikSelect
                  name="PrestadorId"
                  label="Prestador"
                  loading={catalogsLoading}
                  variant="outlined">
                  <MenuItem value="">Todos</MenuItem>
                  {prestadores.map((prestador) => (
                    <MenuItem key={prestador.id} value={prestador.id}>
                      {prestador.nombre}
                    </MenuItem>
                  ))}
                </FormikSelect>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikDatePicker
                  name="FechaDesde"
                  label="Fecha Desde"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikDatePicker
                  name="FechaHasta"
                  label="Fecha Hasta"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikSelect name="Sentido" label="Sentido" variant="outlined">
                  <MenuItem value="Todos">Todos</MenuItem>
                  <MenuItem value="Ida">Ida</MenuItem>
                  <MenuItem value="Vuelta">Vuelta</MenuItem>
                </FormikSelect>
              </Grid>

              {!esPT && (
                <Grid item xs={12} sm={2}>
                  <FormikTextField name="NroTraslado" label="Nro Traslado" type="number" />
                </Grid>
              )}
              <Grid item xs={12} sm={2}>
                <FormikTextField name="NroTramoUnico" label="Nro Tramo" type="number" />
              </Grid>

              <Grid item xs={12} sm={2}>
                <FormikSelect name="EstadoTramoId" label="Estado" loading={catalogsLoading} variant="outlined">
                  <MenuItem value="">Todos</MenuItem>
                  {estados.map((e) => (
                    <MenuItem key={e.id} value={e.id}>{catalogOptionLabel(e)}</MenuItem>
                  ))}
                </FormikSelect>
              </Grid>
              {!esPT && (
                <Grid item xs={12} sm={2}>
                  <FormikSelect name="TipoTransporteId" label="Tipo de Transporte" loading={catalogsLoading} variant="outlined">
                    <MenuItem value="">Todos</MenuItem>
                    {tiposTransporte.map((t) => (
                      <MenuItem key={t.id} value={t.id}>{catalogOptionLabel(t)}</MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
              )}

              <Grid item xs={12} sm={2}>
                <FormikSelect name="ProvinciaOrigen" label="Provincia de Origen" loading={catalogsLoading} variant="outlined">
                  <MenuItem value="">Todas</MenuItem>
                  {provincias.map((p) => (
                    <MenuItem key={p.id} value={p.id}>{catalogOptionLabel(p)}</MenuItem>
                  ))}
                </FormikSelect>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="LocalidadOrigen" label="Localidad de Origen" />
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikSelect name="ProvinciaDestino" label="Provincia de Destino" loading={catalogsLoading} variant="outlined">
                  <MenuItem value="">Todas</MenuItem>
                  {provincias.map((p) => (
                    <MenuItem key={p.id} value={p.id}>{catalogOptionLabel(p)}</MenuItem>
                  ))}
                </FormikSelect>
              </Grid>
              <Grid item xs={12} sm={2}>
                <FormikTextField name="LocalidadDestino" label="Localidad de Destino" />
              </Grid>

              {!esPT && (
                <Grid item xs={12} sm={2}>
                  <FormikSelect name="AgenciaId" label="Agencia" loading={catalogsLoading} variant="outlined">
                    <MenuItem value="">Todas</MenuItem>
                    {agencias.map((a) => (
                      <MenuItem key={a.id} value={a.id}>{catalogOptionLabel(a)}</MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
              )}
              {!esPT && (
                <Grid item xs={12} sm={2}>
                  <FormikSelect name="Gestor" label="Gestor" loading={catalogsLoading} variant="outlined">
                    <MenuItem value="">Todos</MenuItem>
                    {gestores.map((g, index) => (
                      <MenuItem key={index} value={g.id}>{catalogOptionLabel(g)}</MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
              )}
              {!esPT && (
                <Grid item xs={12} sm={2}>
                  <FormikSelect
                    name="PrestadorTrasladoId"
                    label="Prestador Traslado"
                    loading={prestadoresLoading}
                    variant="outlined">
                    <MenuItem value="">Todos</MenuItem>
                    {prestadoresTraslado.map((prestador) => (
                      <MenuItem key={prestador.idPrestador} value={prestador.idPrestador}>
                        {prestador.razonSocial}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
              )}

              {!esPT && (
                <Grid item xs={12} sm={6} display="flex" alignItems="center">
                  <FormikCheckbox name="BuscarSobreRecorridoCompleto" label="Buscar sobre el recorrido completo" />
                </Grid>
              )}
              {esPT && (
                <>
                  <Grid item xs={12} sm={2}>
                    <FormikTextField name="FechaDesde" label="Fecha Desde" type="date" InputLabelProps={{ shrink: true }} />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <FormikTextField name="FechaHasta" label="Fecha Hasta" type="date" InputLabelProps={{ shrink: true }} />
                  </Grid>
                </>
              )}

              <Grid item xs={12} display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  variant="text"
                  onClick={() => {
                    resetForm();
                    onClear();
                  }}
                >
                  Limpiar
                </Button>
                <Button variant="contained" color="primary" type="submit">
                  Buscar
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </StyledPaper.Container>
  );
};

export default BuscarTrasladosFilter;
